import type { Email } from "@src/types/api";

export function getLatestFeedbackValue(email: Email | null | undefined): boolean | undefined {
  const entries = email?.feedback_entries;

  if (entries?.length) {
    const last = entries[entries.length - 1];

    return typeof last?.feedback === "boolean" ? last.feedback : undefined;
  }
  if (typeof email?.feedback === "boolean") return email.feedback;
  return undefined;
}
